import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Slider } from "./ui/slider";
import getCroppedImg from "../lib/cropImage";
import { Loader2 } from "lucide-react";

const PhotoCropDialog = ({ open, src, onClose, onConfirm, busy }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [pixels, setPixels] = useState(null);

  const onComplete = useCallback((_, p) => setPixels(p), []);

  const confirm = async () => {
    let cp = pixels;
    if (!cp) {
      cp = await new Promise((res) => {
        const im = new Image();
        const fallback = () => res({ x: 0, y: 0, width: im.naturalWidth || 600, height: im.naturalHeight || 600 });
        im.onload = () => {
          const s = Math.min(im.naturalWidth, im.naturalHeight) || 600;
          res({ x: (im.naturalWidth - s) / 2, y: (im.naturalHeight - s) / 2, width: s, height: s });
        };
        im.onerror = fallback;
        im.src = src;
        setTimeout(fallback, 2000);
      });
    }
    try {
      const blob = await getCroppedImg(src, cp);
      onConfirm(blob);
    } catch {}
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-md" data-testid="photo-crop-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-[#2A2224]">Fotoğrafı Kırp</DialogTitle>
        </DialogHeader>
        <p className="text-xs text-[#7C6E70] -mt-1">Fotoğrafı sürükleyip yakınlaştırarak ortalayın. Davetiyede daire içinde görünecek.</p>
        <div className="relative w-full h-64 bg-[#1a1416] rounded-xl overflow-hidden">
          {src && (
            <Cropper
              image={src}
              crop={crop}
              zoom={zoom}
              aspect={1}
              cropShape="round"
              showGrid={false}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onComplete}
            />
          )}
        </div>
        <div className="px-1 pt-1">
          <p className="text-xs text-[#7C6E70] mb-2">Yakınlaştır</p>
          <Slider min={1} max={3} step={0.01} value={[zoom]} onValueChange={(v) => setZoom(v[0])} data-testid="crop-zoom-slider" />
        </div>
        <div className="flex gap-2 justify-end pt-1">
          <button onClick={onClose} className="px-4 py-2 rounded-lg border border-[#F0DDE0] text-sm text-[#5b4d4f] hover:bg-[#FBF5F0]" data-testid="crop-cancel">İptal</button>
          <button onClick={confirm} disabled={busy} className="px-4 py-2 rounded-lg bg-[#9E2A3B] text-white text-sm flex items-center gap-2 disabled:opacity-60" data-testid="crop-confirm">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />} Kırp ve Yükle
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PhotoCropDialog;
